export default "/app/global-wrapper-client/static/892baea1814b6000105fae92943e2f5f.ttf";